let language = {
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_HEAD_FROM: "从",
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_HEAD_TO: "至",
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_HEAD_WHITELABLE_PRICE: "标价",
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_HEAD_REVENUE: "利润",
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_HEAD_RETAIL_PRICE: "零售价",
    STORE_PRODUCT_SETTING_SIMPLE_TABLE_PRICE_QTY_MAX: "最大",
};

export { language }
